import chunk from "lodash/chunk";
import { LegacyGetProfilesCollection } from "PFApp/legacy_cv_export_flow";
import { fetchExportProfiles } from "PFCore/services/export_profiles";
import { Id, Match } from "PFTypes";

// Legacy CV export flow copied from uat, used only when the cv_export_legacy_flow feature flag is ON.
// Meant to be removed together with the flag.
export const getLegacyCvExportMatchesCollection = (matches: Match[]) =>
  ((paginationPage = 1, paginationSize = 50) => {
    const items = matches.map(({ profile, scores }) => ({
      id: profile.id,
      _score: (scores as { normalized_score?: number } | undefined)?.normalized_score
    }));
    const paginatedArray = chunk(items, paginationSize);
    return fetchExportProfiles({
      profileIds: paginatedArray[paginationPage - 1].map(({ id }) => id)
    }).then((resp) => ({
      entries: resp.map((profile, i) => ({
        profile: { ...profile, score: items[i]._score }
      })),
      meta: { total: resp.length, page: paginationPage }
    }));
  }) as LegacyGetProfilesCollection;

export const getLegacyCvExportProfilesCollection = (profiles: { id: Id }[]) =>
  ((paginationPage = 1, paginationSize = 50) =>
    fetchExportProfiles({
      profileIds: profiles.map(({ id }) => id),
      page: paginationPage,
      perPage: paginationSize
    }).then((resp) => ({
      entries: resp.map((profile) => ({
        profile
      })),
      meta: { total: resp.length, page: paginationPage }
    }))) as LegacyGetProfilesCollection;
